<template>
  <div ref="caseQuickSelect" class="caseQuickSelect">
    <div class="caseQuickSelect_content">
      <el-input
        ref="case_select_input"
        :class="{ 'caseQuickSelect_input': true, 'hasPulse': id === 'facePalpation', 'isInvalid': !valid }"
        :value="value"
        type="textarea"
        resize="none"
        autosize
        :rows="2"
        placeholder=""
        maxlength="2000"
        :disabled="disabled"
        @input="caseInput"
        @blur="caseBlur">
      </el-input>
      <el-button v-if="!disabled && (id == 'facePalpation')" class="caseQuickSelect_pulse_btn" type="text" @click="openPulse">脉象选择</el-button>
      <el-button v-if="!disabled" class="caseQuickSelect_open_btn" type="text" @click="openQuick">快捷选项</el-button>
    </div>
    <div class="pannel" v-show="visible">
      <template v-if="!['physicalExamination'].includes(id)">
        <div class="pannel_content">
          <div v-for="(section, sectionIndex) in list" :key="section.id">
            <div class="pannel_section">
              <div class="pannel_section_content">
                <div v-for="block in section.children" :key="block.id" class="pannel_block">
                  <div v-show="block.title" class="pannel_block_title">{{ block.title }}</div>
                  <div class="pannel_block_content">
                    <div v-show="block.label" class="pannel_block_label">{{ block.label }}</div>
                    <div class="pannel_block_info">
                      <div v-for="(row, rowIndex) in block.children" :key="rowIndex" class="pannel_block_info_row">
                        <div v-for="option in row" :key="option.id" class="pannel_block_info_item" @click="optionOn(option)">{{ option.label }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="sectionIndex < (list.length - 1)" class="section_line"></div>
          </div>
        </div>
      </template>
      <!-- 体格检查 -->
      <template v-if="['physicalExamination'].includes(id)">
        <div class="pannel_tab_list">
          <div v-for="section in list" :class="{ 'pannel_tab_item': true, 'active': physicalExaminationMap.activeId == section.id }" @click="physicalExaminationTabOn(section.id)">{{ section.label }}</div>
        </div>
        <div class="pannel_content">
          <div v-for="section in list" :key="section.id" class="pannel_section">
            <template v-if="physicalExaminationMap.activeId == section.id">
              <template v-if="['06'].includes(section.id)">
                <div class="pannel_section_content">
                  <div class="pannel_menu_block">
                    <div class="pannel_menu_list">
                      <div v-for="block in section.children" :key="block.id" :class="{ 'pannel_menu_item': true, 'active': physicalExaminationMap.weightActiveId == block.id }" @click="physicalExaminationMenuWeightOn(block.id)">{{ block.label }}</div>
                    </div>
                    <div class="pannel_menu_content">
                      <div v-for="block in section.children" :key="block.id" class="pannel_menu_content_block">
                        <div v-show="physicalExaminationMap.weightActiveId == block.id" class="pannel_block_info">
                          <div v-for="(row, rowIndex) in block.children" :key="rowIndex" class="pannel_block_info_row">
                            <div v-for="option in row" :key="option.id" class="pannel_block_info_item" @click="optionOn(option)">{{ option.label }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="['07'].includes(section.id)">
                <div class="pannel_section_content">
                  <div class="pannel_menu_block">
                    <div class="pannel_menu_list">
                      <div v-for="block in section.children" :key="block.id" :class="{ 'pannel_menu_item': true, 'active': physicalExaminationMap.heightActiveId == block.id }" @click="physicalExaminationMenuheightOn(block.id)">{{ block.label }}</div>
                    </div>
                    <div class="pannel_menu_content">
                      <div v-for="block in section.children" :key="block.id" class="pannel_menu_content_block">
                        <div v-show="physicalExaminationMap.heightActiveId == block.id" class="pannel_block_info">
                          <div v-for="(row, rowIndex) in block.children" :key="rowIndex" class="pannel_block_info_row">
                            <div v-for="option in row" :key="option.id" class="pannel_block_info_item" @click="optionOn(option)">{{ option.label }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="!['06', '07'].includes(section.id)">
                <div class="pannel_section_content">
                  <div v-for="block in section.children" :key="block.id" class="pannel_block">
                    <div v-show="block.title" class="pannel_block_title">{{ block.title }}</div>
                    <div class="pannel_block_content">
                      <div v-show="block.label" class="pannel_block_label">{{ block.label }}</div>
                      <div class="pannel_block_info">
                        <div v-for="(row, rowIndex) in block.children" :key="rowIndex" class="pannel_block_info_row">
                          <div v-for="option in row" :key="option.id" class="pannel_block_info_item" @click="optionOn(option)">{{ option.label }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div v-show="section.right" class="pannel_section_right">{{ section.right }}</div>
            </template>
          </div>
        </div>
      </template>
      
      <div class="pannel_footer" @click="closeQuick">
        <span class="el-icon-circle-close pannel_footer_icon"></span>
        <span class="pannel_footer_text">关闭</span>
      </div>
    </div>
    <!-- 脉象 -->
    <div class="pulse_pannel" v-show="pulseVisible">
      <div class="pulse_pannel_block">
        <div class="pulse_first_list">
          <div v-for="first in pulseMap.firstList" :key="first.id" :class="{ 'pulse_list_item': true, 'active': pulseMap.firstValues.includes(first.id) }" @click="pulseOn('first', first.id)">{{ first.label }}</div>
        </div>
        <div class="pulse_second_list">
          <div v-for="second in pulseMap.secondList" :key="second.id" :class="{ 'pulse_list_item': true, 'active': pulseMap.secondValues.includes(second.id) }" @click="pulseOn('second', second.id)">{{ second.label }}</div>
        </div>
        <div class="pulse_third_list">
          <div v-for="third in pulseMap.thirdList" :key="third.id" :class="{ 'pulse_list_item': true, 'active': pulseMap.thirdValues.includes(third.id) }" @click="pulseOn('third', third.id)">{{ third.label }}</div>
        </div>
      </div>
      <div class="pulse_pannel_footer">
        <div class="pulse_pannel_result">{{ pulseResult }}</div>
        <div class="pulse_pannel_confirm" @click="confirmPulse">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
  import caseConfig from './caseConfig.json'
  export default {
    name: 'caseQuickSelect',
    props: {
      value: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: false,
        pulseVisible: false,
        list: [],
        cursorIndex: null,
        valid: true,
        physicalExaminationMap: {
          activeId: '01',
          weightActiveId: '06-01',
          heightActiveId: '07-01'
        },
        pulseMap: {
          firstList: [
            { id: '01-01', label: '左', value: '左' },
            { id: '01-02', label: '右', value: '右' }
          ],
          secondList: [
            { id: '02-01', label: '寸', value: '寸' },
            { id: '02-02', label: '关', value: '关' },
            { id: '02-03', label: '尺', value: '尺' }
          ],
          thirdList: [
            { id: '03-01', label: '浮', value: '浮' },
            { id: '03-02', label: '沉', value: '沉' },
            { id: '03-03', label: '迟', value: '迟' },
            { id: '03-04', label: '数', value: '数' },
            { id: '03-05', label: '虚', value: '虚' },
            { id: '03-06', label: '实', value: '实' },
            { id: '03-07', label: '濡', value: '濡' },
            { id: '03-08', label: '弱', value: '弱' },
            { id: '03-09', label: '缓', value: '缓' },
            { id: '03-10', label: '促', value: '促' },
            { id: '03-11', label: '细', value: '细' },
            { id: '03-12', label: '弦', value: '弦' },
            { id: '03-13', label: '洪', value: '洪' },
            { id: '03-14', label: '伏', value: '伏' },
            { id: '03-15', label: '涩', value: '涩' },
            { id: '03-16', label: '动', value: '动' },
            { id: '03-17', label: '微', value: '微' },
            { id: '03-18', label: '滑', value: '滑' },
            { id: '03-19', label: '芤', value: '芤' },
            { id: '03-20', label: '牢', value: '牢' },
            { id: '03-21', label: '结', value: '结' },
            { id: '03-22', label: '疾', value: '疾' },
            { id: '03-23', label: '代', value: '代' },
            { id: '03-24', label: '紧', value: '紧' }
          ],
          firstValues: [],
          secondValues: [],
          thirdValues: []
        }
      }
    },
    computed: {
      pulseResult () {
        let text = ''

        if ((this.pulseMap.firstValues && this.pulseMap.firstValues.length > 0) && (this.pulseMap.thirdValues && this.pulseMap.thirdValues.length > 0)) {
          this.pulseMap.firstList.forEach(v => {
            if (this.pulseMap.firstValues.includes(v.id)) {
              text = text + v.value
            }
          })
          this.pulseMap.secondList.forEach(v => {
            if (this.pulseMap.secondValues.includes(v.id)) {
              text = text + v.value
            }
          })
          text = text + '脉'
          this.pulseMap.thirdList.forEach(v => {
            if (this.pulseMap.thirdValues.includes(v.id)) {
              text = text + v.value
            }
          })
        }

        return text
      }
    },
    methods: {
      caseInput (e) {
        this.$emit('input', e)
      },
      caseBlur (e) {
        if (this.visible) {
          this.cursorIndex = e.srcElement.selectionStart
        } else {
          this.caseValidate()
        }
      },
      caseValidate () {
        if (this.required) {
          this.valid = !['', null, undefined].includes(this.value)
        }
      },
      caseClearValidate () {
        this.valid = true
      },
      openQuick () {
        this.pulseVisible = false
        this.visible = true

        this.list = caseConfig[this.id] && caseConfig[this.id].list || []

        this.cursorIndex = this.value.length

        if (this.visible) {
          setTimeout(() => {
            document.addEventListener('click', this.clickOutside)
          }, 0)
        }
      },
      closeQuick () {
        this.visible = false
        this.cursorIndex = null
        this.removeListener()
        this.caseValidate()
      },
      clickOutside (e) {
        const container = this.$refs.caseQuickSelect
        if (container && !container.contains(e.target)) {
          this.closeQuick()
          this.closePulse()
        }
      },
      removeListener() {
        document.removeEventListener('click', this.clickOutside)
      },
      optionOn (option) {
        const val = this.value && this.value.toString() || ''
        const startStr = val.substring(0, this.cursorIndex)
        const endStr = val.substring(this.cursorIndex)
        let text = ''

        if (option.type == 'default') {
          const regexp = new RegExp(option.value)
          if (!regexp.test(this.value)) {
            text = `${((startStr.trim() == '') || (/[，,]$/.test(startStr))) ? '' : '，'}${option.value}${((endStr.trim() == '') || (/^[，,]/.test(endStr))) ? '' : '，'}`
            const result = `${startStr}${text}${endStr}`
            this.$emit('input', result)
          }
        }

        if (option.type == 'regRxp') {
          const regexp = new RegExp(option.regRxp)
          if (!regexp.test(this.value)) {
            text = `${((startStr.trim() == '') || (/[，,]$/.test(startStr))) ? '' : '，'}${option.value}${((endStr.trim() == '') || (/^[，,]/.test(endStr))) ? '' : '，'}`
            const result = `${startStr}${text}${endStr}`
            this.$emit('input', result)
          } else {
            const oldValue = this.value.match(regexp)[0]
            this.cursorIndex = this.cursorIndex + (option.value.length - oldValue.length)

            const result = this.value.replace(regexp, option.value)
            this.$emit('input', result)
          }
        }

        if (option.type == 'special') {
          // 体格检查
          if (this.id == 'physicalExamination') {
            const blockId = option.id.substring(0, 2)
            // 血压
            if (blockId == '05') {
              const regexp = new RegExp(option.regRxp)
              if (!regexp.test(this.value)) {
                text = `${((startStr.trim() == '') || (/[，,]$/.test(startStr))) ? '' : '，'}${option.value}${((endStr.trim() == '') || (/^[，,]/.test(endStr))) ? '' : '，'}`
                const result = `${startStr}${text}${endStr}`
                this.$emit('input', result)
              } else {
                const oldValue = this.value.match(regexp)[0]

                const result = this.value.replace(regexp, (m, p1, oldSys, sep, oldDia, unit) => {
                  const sys = option.systolicNum ? option.systolicNum : (oldSys || '')
                  const dia = option.diastolicNum ? option.diastolicNum : (oldDia || '')
                  return `${p1.trim()} ${sys} ${sep.trim()} ${dia} ${unit.trim()}`
                })

                const newValue = result.match(regexp)[0]

                this.cursorIndex = this.cursorIndex + (newValue.length - oldValue.length)

                this.$emit('input', result)
              }
            }
            // 血氧、血糖
            if (blockId == '08' || blockId == '09') {
              text = `${((startStr.trim() == '') || (/[，,]$/.test(startStr))) ? '' : '，'}${option.value}${((endStr.trim() == '') || (/^[，,]/.test(endStr))) ? '' : '，'}`
              const result = `${startStr}${text}${endStr}`
              this.$emit('input', result)
            }
          }
        }

        this.$nextTick(() => {
          const inputEl = this.$refs['case_select_input'].$el.querySelector('textarea')
          if (inputEl) {
            inputEl.focus()
            const newPos = this.cursorIndex + text.length
            inputEl.setSelectionRange(newPos, newPos)
            this.cursorIndex = newPos
          }
        })
      },
      // 体格检查
      physicalExaminationTabOn (id) {
        this.physicalExaminationMap.activeId = id
      },
      physicalExaminationMenuWeightOn (id) {
        this.physicalExaminationMap.weightActiveId = id
      },
      physicalExaminationMenuheightOn  (id) {
        this.physicalExaminationMap.heightActiveId = id
      },
      openPulse () {
        this.visible = false
        this.pulseVisible = true
        if (this.pulseVisible) {
          setTimeout(() => {
            document.addEventListener('click', this.clickOutside)
          }, 0)
        }
      },
      closePulse () {
        this.pulseVisible = false

        this.pulseMap.firstValues = []
        this.pulseMap.secondValues = []
        this.pulseMap.thirdValues = []

        this.removeListener()
        this.caseValidate()
      },
      pulseOn (type, id) {
        switch (type) {
          case 'first':
            const hasFirstIndex = this.pulseMap.firstValues.findIndex(v => { return v === id })
            if (hasFirstIndex > -1) {
              this.pulseMap.firstValues.splice(hasFirstIndex, 1)
            } else {
              this.pulseMap.firstValues = [id]
            }
            break
          case 'second':
            const hasSecondIndex = this.pulseMap.secondValues.findIndex(v => { return v === id })
            if (hasSecondIndex > -1) {
              this.pulseMap.secondValues.splice(hasSecondIndex, 1)
            } else {
              this.pulseMap.secondValues.push(id)
            }
            break
          case 'third':
            const hasThirdIndex = this.pulseMap.thirdValues.findIndex(v => { return v === id })
            if (hasThirdIndex > -1) {
              this.pulseMap.thirdValues.splice(hasThirdIndex, 1)
            } else {
              this.pulseMap.thirdValues.push(id)
            }
            break
        }
      },
      confirmPulse () {
        if (this.pulseResult) {
          const text = `${((this.value.trim() == '') || (/[，,]$/.test(this.value))) ? '' : '，'}${this.pulseResult}`
          const result = `${this.value}${text}`
          this.$emit('input', result)
          this.$nextTick(() => {
            this.caseValidate()
          })
        }
        this.closePulse()
      }
    },
    beforeDestroy () {
      this.removeListener()
    }
  }
</script>

<style lang="less" scoped>
  .caseQuickSelect {
    position: relative;
    width: 100%;
    border-bottom: 1px solid #E0E0E0;
  }

  .caseQuickSelect_content {
    position: relative;
    width: 100%;
  }

  .caseQuickSelect_input /deep/ .el-textarea__inner {
    padding: 5px 82px 5px 15px;
    min-height: 39px !important;
    line-height: 22px;
    border: none;
  }

  .caseQuickSelect_input.hasPulse /deep/ .el-textarea__inner {
    padding: 5px 164px 5px 15px;
  }

  .caseQuickSelect_input.isInvalid /deep/ .el-textarea__inner {
    border: 1px solid #F54A45;
  }

  .caseQuickSelect_open_btn {
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    top: 0px;
    right: 0px;
    padding: 8px 12px;
    width: 82px;
    height: 40px;
  }

  .caseQuickSelect_pulse_btn {
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    top: 0px;
    right: 82px;
    padding: 8px 12px;
    width: 82px;
    height: 40px;
    color: #929aa6;
    border-radius: 8px;
  }

  .caseQuickSelect_pulse_btn:hover {
    background-color: rgba(56, 80, 104, 0.08);
  }

  .pannel {
    position: absolute;
    z-index: 99;
    top: calc(100% + 4px);
    right: 0px;
    width: 95%;
    background-color: #FFFFFF;
    border: 1px solid #b7b9c2;
    border-radius: 4px;
    box-shadow: 0 3px 12px 2px rgba(0, 0, 0, .1);
    user-select: none;
  }

  .pannel_tab_list {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #dadbe0;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .pannel_tab_item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
    height: 100%;
    font-size: 14px;
    cursor: pointer;
  }

  .pannel_tab_item.active {
    font-weight: 600;
  }

  .pannel_tab_item.active::after {
    content: '';
    position: absolute;
    z-index: 2;
    bottom: -1px;
    left: 0px;
    display: block;
    width: 100%;
    height: 3px;
    background-color: #1485ee;
  }

  .pannel_tab_item + .pannel_tab_item {
    margin: 0 0 0 8px;
  }

  .pannel_content {
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
  }

  .pannel_section {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    width: 100%;
  }

  .section_line {
    box-sizing: border-box;
    margin: 8px;
    width: calc(100% - 16px);
    height: 0px;
    border-bottom: 1px solid #dadbe0;
  }

  .pannel_section_content {
    flex-grow: 1;
    width: 100%;
  }

  .pannel_block {
    width: 100%;
  }

  .pannel_block + .pannel_block {
    margin: 8px 0 0 0;
  }

  .pannel_block_title {
    margin: 0 8px 6px;
    font-weight: 600;
    font-size: 14px;
  }

  .pannel_block_content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  
  .pannel_block_label {
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 5px 8px;
    min-width: 90px;
    line-height: 1;
    font-weight: 600;
    font-size: 14px;
  }

  .pannel_menu_block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .pannel_menu_list {
    flex-shrink: 0;
    width: 126px;
  }

  .pannel_menu_item {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 8px;
    width: 100%;
    height: 32px;
    font-size: 14px;
    color: #000000;
    border-radius: 8px;
    cursor: pointer;
  }

  .pannel_menu_item.active {
    background-color: #e0efff;
  }

  .pannel_menu_item:hover {
    background-color: #f2f4f7;
  }

  .pannel_menu_item + .pannel_menu_item {
    margin: 4px 0 0 0;
  }

  .pannel_menu_content {
    flex-grow: 1;
    min-width: 0px;
  }

  .pannel_menu_content_block {
    width: 100%;
  }

  .pannel_block_info {
    flex-grow: 1;
    min-width: 0px;
  }

  .pannel_block_info_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .pannel_block_info_item {
    box-sizing: border-box;
    padding: 5px 8px;
    min-width: 42px;
    text-align: center;
    line-height: 1;
    font-size: 14px;
    color: #7a8794;
    white-space: nowrap;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
  }

  .pannel_block_info_item:hover {
    color: #0090ff;
    background-color: #c6e2ff;
  }

  .pannel_section_right {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 18px;
    font-size: 24px;
    color: #7a8794;
  }

  .pannel_footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    background-color: #f7f7f7;
    cursor: pointer;
  }

  .pannel_footer_icon {
    font-size: 16px;
    color: #005ed9;
  }

  .pannel_footer_text {
    margin: 0 0 0 8px;
    font-weight: 500;
    font-size: 14px;
    color: #005ed9;
  }

  .pulse_pannel {
    position: absolute;
    z-index: 99;
    top: calc(100% + 4px);
    right: 0px;
    width: 360px;
    background-color: #FFFFFF;
    border: 1px solid #b7b9c2;
    border-radius: 4px;
    box-shadow: 0 3px 12px 2px rgba(0, 0, 0, .1);
    user-select: none;
  }

  .pulse_pannel_block {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
  }

  .pulse_first_list {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 32px);
    justify-content: space-between;
    padding: 0 90px;
    width: 100%;
  }

  .pulse_second_list {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 32px);
    justify-content: space-between;
    margin: 12px 0 0 0;
    padding: 0 32px;
    width: 100%;
  }

  .pulse_third_list {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(6, 32px);
    justify-content: space-between;
    margin: 12px 0 0 0;
    row-gap: 12px;
    width: 100%;
  }

  .pulse_list_item {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    font-size: 14px;
    color: #5f6a7a;
    border: 1px solid #dfe2e8;
    border-radius: 50%;
    cursor: pointer;
  }

  .pulse_list_item:hover {
    background-color: rgba(2, 10, 26, 0.04);
  }

  .pulse_list_item.active {
    color: #FFFFFF;
    background-color: #1485ee;
  }

  .pulse_pannel_footer {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 48px;
    border-top: 1px solid #dadbe0;
  }

  .pulse_pannel_result {
    flex-grow: 1;
    min-width: 0px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pulse_pannel_confirm {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 24px;
    width: 64px;
    height: 30px;
    font-size: 14px;
    color: #FFFFFF;
    background-color: #07c160;
    border-radius: 50px;
    cursor: pointer;
  }
</style>
